import { Fragment } from 'react';

import Views from '../AthleteUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeAthleteEntry/ViewTemplate';

import useAthleteUserContacts from './UseAthleteUserContacts';

import AthleteUserContactsGrid from './AthleteUserContactsGrid';

import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const AthleteUserContacts = () => {
  const { state, athleteEntryContextState, orgUnitAthleteContactState, onNextButtonClicked, onSaveAndExitButtonClicked,
    onAddContact, onEditContact, onDeleteContactClicked, onDeleteContact, onModalCanceled, modalState, Constants, isLoading } = useAthleteUserContacts();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_CONTACTS}
        onNextButtonClicked={onNextButtonClicked}
        onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
        errorMessage={state.error}
      >
        {athleteEntryContextState.isReadOnly === false ?
          <Fragment>
            <div className="row">
              <div className={athleteEntryContextState.isUnattached === true ? global.DisplayComponent : global.HideComponent}>
                <div className="col-xs-12">
                  <ActionIntraPageButton onClick={onAddContact}>Add Entry Contact</ActionIntraPageButton>
                </div>
                <div className='col-xs-12'>
                  <AthleteUserContactsGrid
                    gridData={orgUnitAthleteContactState.arrayData}
                    isLoading={orgUnitAthleteContactState.isArrayLoading}
                    onEditContact={onEditContact}
                    onDeleteContactClicked={onDeleteContactClicked}
                  />
                </div>
              </div>
            </div>
            <PopUpModal
              widthPct={50}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={isLoading} />
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.SAVING_MSG}
              displayPopUp={orgUnitAthleteContactState.isSaving} />
            <PopUpModal
              widthPct={90}
              maxWidth={720}
              title={modalState.modalTitle}
              displayPopUp={modalState.displayPopUp}
              onModalCanceled={onModalCanceled}>
              <div className="row">
                <div className="col-xs-12">
                  <p><strong>Entry Contact Name:</strong> {modalState?.contactName}</p>
                  <p><strong>Email:</strong> {modalState?.emailAddress}</p>
                </div>
                <div className="col-xs-12 usas-extra-top-margin">
                  <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
                  <PrimaryButton type="button" onClick={(e) => onDeleteContact(e, modalState.orgUnitAthleteContactId)}>Delete</PrimaryButton>
                </div>
              </div>
            </PopUpModal>
          </Fragment> :
          <Fragment>
            <div className="row">
              <div className={athleteEntryContextState.isUnattached === true ? global.DisplayComponent : global.HideComponent}>
                <div className='col-xs-12'>
                  <AthleteUserContactsGrid
                    gridData={orgUnitAthleteContactState.arrayData}
                    isLoading={orgUnitAthleteContactState.isArrayLoading}
                  />
                </div>
              </div>
            </div>
            <PopUpModal
              widthPct={50}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={isLoading} />
          </Fragment >
        }
      </ViewTemplate>
    </Fragment>
  );
};

export default AthleteUserContacts;